/**
 * Actions Types
 */

import { TipoDocs } from '../listaDocumentos/types'

export enum DocumentosAssinaturaTypes {
  SET_DOCUMENTOS = '@refinanciamento/documentosAssinatura/SET_DOCUMENTOS',
  SET_ID_ITERACAO = '@refinanciamento/documentosAssinatura/SET_ID_ITERACAO',
  SET_DOCUMENTO_REVISAO = '@refinanciamento/documentosAssinatura/SET_DOCUMENTO_REVISAO',
  SET_CHECK_MESSAGE_REVISAO = '@refinanciamento/documentosAssinatura/SET_CHECK_MESSAGE_REVISAO',
  SET_TITLE_DOCUMENTO_REVISAO = '@refinanciamento/documentosAssinatura/SET_TITLE_DOCUMENTO_REVISAO',
  RESET = 'RESET',
  SET_LOADING = '@refinanciamento/documentosAssinatura/SET_LOADING',

  SEND_ASSINATURA = '@refinanciamento/documentosAssinatura/SEND_ASSINATURA',
  FINALIZAR_PROPOSTA = '@refinanciamento/documentosAssinatura/FINALIZAR_PROPOSTA',
  FINALIZAR_PROPOSTA_ERROR = '@refinanciamento/documentosAssinatura/FINALIZAR_PROPOSTA_ERROR',
  FINALIZAR_PROPOSTA_SUCCESS = '@refinanciamento/documentosAssinatura/FINALIZAR_PROPOSTA_SUCCESS',

  SEND_DOCUMENTO_ASSINCRONO = '@refinanciamento/documentosAssinatura/SEND_DOCUMENTO_ASSINCRONO',
}

/**
 * State Type
 */

export interface DocumentosAssinaturaState {
  readonly documentos: {
    idTipoDocumento: TipoDocs
  }[]
  readonly idIteracao: number | string
  readonly documentoRevisao: TipoDocs
  readonly checkMessageRevisao: string
  readonly tituloDocumentoRevisao: string
  readonly loading: boolean
  readonly loadingFinalizarProposta: boolean
  readonly erroFinalizarProposta: boolean
  readonly propostaFinalizada: boolean
}

export type FinalizarPropostaPayload = {
  callback: () => void
  callbackTryAgain?: () => void
}

export type AssinaturaDataType = {
  timestamp_assinatura: string
  ip_cliente: string
  id_documentos_assinatura: string
}
export type ReturnType = {
  data: AssinaturaDataType
}

export type GerarPayload = {
  tipo: TipoDocs
  assinaturaData: AssinaturaDataType
  type: string
}

export interface BuscarDocumentosAssinaturaPayload {
  callback: () => void
}
